var circles_cache = {};

// Get next point from defined circle and time and offset
export function getPointOnCircle(circle, time, x, y) {
	let new_x = x + Math.cos((time * circle.gear + circle.offset)) * circle.radius;
	let new_y = y + Math.sin((time * circle.gear + circle.offset)) * circle.radius;
	return [new_x, new_y];
}

export function findBestCircle(circles, points, sample_step) {
	let max = 12;
	let count = 0;
	let itercount = 0;
	let bestcount = 0;
	let best = {
		radius: 0,
		gear: 0,
		offset: 0
	};

	if (circles.length < Object.keys(circles_cache).length) {
		circles_cache = {};
	}

	if (circles.length < 12)
		max = circles.length + 2;

	let used_circles = circles.map(circle => circle.gear);
	let prepared_data = prepareTestCircle(circles, points, sample_step);
	let cached = false;
	while (itercount < max) {
		let gear = Math.ceil(count / 2);
		if (count & 1)
			gear = -gear;
		if (!used_circles.includes(gear)) {
			itercount++;
			let radius;
			let offset;
			if (gear in circles_cache) {
				[radius, offset] = circles_cache[gear];
				cached = true;
			} else {
				[radius, offset] = testCircle(prepared_data, gear, sample_step);
				circles_cache[gear] = [radius, offset];
				cached = false;
			}
			if (radius > best.radius) {
				best = {
					radius: radius,
					gear: gear,
					offset: offset
				}
				bestcount = itercount;
				if (gear === 0)
					return best;
			}
		}
		count++;
	}
	if (cached) {
		let [radius, offset] = testCircle(prepared_data, best.gear, sample_step);
		best = {
			radius: radius,
			gear: best.gear,
			offset: offset
		}
	}
	return (best);
}

export function updateCirclePositions(circles, time) {
	let x = 0, y = 0;

	for (let i = 0; i < circles.length; i++) {
		let [new_x, new_y] = getPointOnCircle(circles[i], time, x, y);
		circles[i] = {
			...circles[i],
			center_x: x,
			center_y: y,
			x: new_x,
			y: new_y
		};
		x = new_x;
		y = new_y;
	}
}

function testCircle(prepared_data, gear, sample_step) {
	let acc_x = 0;
	let acc_y = 0;
	let i = 0;
	let used_numbers = 0;
	for (let time = 0; time < Math.PI * 2; time += sample_step) {
		let [x, y, ignore] = prepared_data[i++];
		if (true || !ignore) {
			let [rx, ry] = rotate(x, y, time * gear);
			acc_x += rx;
			acc_y += ry;
			used_numbers++;
		}
	}
	acc_x = acc_x / used_numbers; //((2 * Math.PI) / sample_step);
	acc_y = acc_y / used_numbers; //((2 * Math.PI) / sample_step);
	let [radius, offset] = getAngle(acc_x, acc_y);
	return [radius, offset];
}

function getAngle(x, y) {
	// angle in radians
	let angleRadians = Math.atan2(y, x);
	if (angleRadians < 0) {
		angleRadians += Math.PI * 2;
	}
	let distance = Math.sqrt(x * x + y * y);
	return [distance, angleRadians];
}

function rotate(x, y, radians) {
	let cos = Math.cos(radians);
	let sin = Math.sin(radians);
	let nx = (cos * x) + (sin * y);
	let ny = (cos * y) - (sin * x);
	return [nx, ny];
}

// Get the diff between the circle points and origin
function getDiffInTime(circles, points, time) {
	let x = 0, y = 0;
	for (let i = 0; i < circles.length; i++) {
		[x, y] = getPointOnCircle(circles[i], time, x, y);
	}
	let [org_x, org_y] = getOrigin(points, time);
	return [org_x - x, org_y - y];
}

function prepareTestCircle(circles, points, sample_step) {
	let data = [];
	for (let time = 0; time < Math.PI * 2; time += sample_step) {
		// eslint-disable-next-line
		let [dummy1, dummy2, start] = getOrigin(points, time);
			let [x, y] = getDiffInTime(circles, points, time);
			data.push([x, y, start]);
	}
	return data;
}

export function getOrigin(points, time) {
	if (points.length > 0) {
		let index = (points.length / (Math.PI * 2)) * time;
		let p1 = points[Math.floor(index)];
		let p2 = points[index >= points.length - 1 ? 0 : Math.ceil(index)];
		let dec = index - Math.floor(index);

		let [x1, y1, end1] = p1;
		let [x2, y2] = p2;
		let x = x1 + (x2 - x1) * dec;
		let y = y1 + (y2 - y1) * dec;
		return [x, y, end1];
	}
	return [0, 0, false];
}
